export class DispatchDropLocation
{
    status: any;
    tech: any;
    dateTime: any;
    dropTarget: number;
    popup: boolean;
    dispatchId: any;
    dispatchAssignmentId: any;
}
